import { render, staticRenderFns } from "./Onglet.vue?vue&type=template&id=af45a95c"
import script from "./Onglet.vue?vue&type=script&lang=js"
export * from "./Onglet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports